import { Toast } from '@models/toast';
import { Injectable } from "@angular/core";
import { ActiveToast, ToastrService } from 'ngx-toastr';

@Injectable()
export class ToastsManager {

    constructor(private toastr: ToastrService) {
    }

    setRootViewContainerRef(vRef: any) {
        return false;
    }


    info(message: string, title?: string, options?: any): ActiveToast<any> {
        return this.toastr.info(message, title, options);
    };

    success(message: string, title?: string, options?: any): ActiveToast<any> {
        return this.toastr.success(message, title, options);
    };

    warning(message: string, title?: string, options?: any): ActiveToast<any> {
        return this.toastr.warning(message, title, options);
    };

    error(message: string, title?: string, options?: any): ActiveToast<any> {
        return this.toastr.error(message, title, options);
    };

    custom(message: string, title?: string, options?: any): ActiveToast<any> {
        return null
    };
}
